const FreeShip = ({ className }: { className?: string }) => {
  return (
    <svg
      width="36"
      height="35"
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2096 0C11.901 0 10.0303 1.865 10.0303 4.16667V6.66667H3.34343C1.49619 6.66667 0 8.15833 0 10V16.6667H2.50758C4.81622 16.6667 6.68687 18.5317 6.68687 20.8333C6.68687 23.135 4.81622 25 2.50758 25H0V31.6667C0 33.5083 1.49619 35 3.34343 35H10.0303V32.5C10.0303 30.1983 11.901 28.3333 14.2096 28.3333C16.5182 28.3333 18.3889 30.1983 18.3889 32.5V35H25.0758C26.923 35 28.4192 33.5083 28.4192 31.6667V25H30.9268C33.2354 25 35.1061 23.135 35.1061 20.8333C35.1061 18.5317 33.2354 16.6667 30.9268 16.6667H28.4192V10C28.4192 8.15833 26.923 6.66667 25.0758 6.66667H18.3889V4.16667C18.3889 1.865 16.5182 0 14.2096 0Z"
        fill="#FB2576"
      />
    </svg>
  );
};

export default FreeShip;
